/**
 * A test project (Jason, 2026-10-07: "update the test project language cause it seems like now all projects can be
 * deleted now"): one kept off the Projects page, for trying things (`is_sample` in the database and `isSample` on the
 * wire, unchanged). Any project is deleted the same way, from the foot of its Settings, so nothing here says a test
 * project is the one that can be. Every word a person reads about one comes from here (`TestProject.tsx` draws them).
 */
const KEPT = 'kept off the Projects page, for trying things';

export const TEST_PROJECT_WORDS = {
  /** What one is, after its name or a count of them (Development tools, Test projects). */
  kept: KEPT,
  /** Its tag beside its name, wherever a project is listed. */
  tag: 'test',
  /** The box on a new project or lead. */
  choose: `Test project (${KEPT})`,
  /** The box on the Projects page that lists them too. */
  show: 'Show test projects',
} as const;
